/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';
import { color } from '@coursera/coursera-ui';
import { SvgCheckSolid } from '@coursera/coursera-ui/svg';

import ProgressCircle from 'bundles/ui/components/ProgressCircle';

import _t from 'i18n!nls/author-common';

type Props = {
  active?: boolean;
  completed?: boolean;

  title: string;
  stepNumber: number;

  children: React.ReactNode;
  onNext?: () => void;
  className?: string;
};

const SetupPanel = (props: Props) => {
  const { title, completed } = props;

  return (
    <div css={(theme: Theme) => ({ marginBottom: 'var(--cds-spacing-300)' })}>
      <Grid container direction="row" spacing={16}>
        <Grid container item xs={1} direction="column" justifyContent="center" alignItems="center">
          {completed ? (
            <SvgCheckSolid fill={color.success} size={24} title={_t('Completed')} />
          ) : (
            <ProgressCircle percentComplete={0} innerColor={color.white} backgroundColor={color.secondaryText} />
          )}
        </Grid>
        <Grid container item direction="column" justifyContent="center" xs={11}>
          <Typography2 component="h3" variant="subtitleMedium">
            {title}
          </Typography2>
        </Grid>
      </Grid>
      <Grid
        direction="row"
        spacing={16}
        css={(theme: Theme) => ({ padding: 'var(--cds-spacing-150) var(--cds-spacing-800)' })}
      >
        {props.children}
      </Grid>
    </div>
  );
};

export default SetupPanel;
